const pricing = [
  {
    id: 1,
    title: 'Starter Plan',
    content: 'ideal for small startups',
    price: 50,
    features: [
      'AI-powered solutions',
      'Data analytics',
      'Cloud computing',
      'IT consulting',
      'Technical support',
    ],
  },
  {
    id: 2,
    title: 'Advanced Plan',
    content: 'ideal for growing businesses',
    price: 100,
    features: [
      'AI-powered solutions',
      'Data analytics',
      'Cloud computing',
      'IT consulting',
      'Technical support',
    ],
  },
  {
    id: 3,
    title: 'Enterprise Plan',
    content: 'ideal for large corporations',
    price: 200,
    features: [
      'AI-powered solutions',
      'Data analytics',
      'Cloud computing',
      'IT consulting',
      'Technical support',
    ],
  },
];

export default pricing;